import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "services/common/rtkQueryConfig";

export class Survey {
    id?: string;
    createdDate?: Date;
    completedDate?: Date;
    displayedRecentDate?: Date[] = [];
    displayedCount = 0;
    type!: SurveyType;
    score?: number;
    feedbacks?: Feedback[] = [];
    version?: string;
    triggerPoint?: TriggerPoint;
    updatedOn?: Date;
    notifiedBy?: string;
    notifiedDate?: Date;
    notifiedId?: string;
    device?: string;
    inquiryId?: string;
    dealId?: string;
    loanId?: string;
    dealApplicationId?: string;
    prospectId?: string;
    borrowerType?: DealRoleType;
    nhUserId!: string;
    nhDealApplicationId?: string;
}

export class CreateSurveyDto {
    type!: SurveyType;
    Device?: string;
    triggerPoint?: TriggerPoint;
}

export class Feedback {
    question?: string;
    answer?: string;
}

export enum SurveyType {
    NPS = "0",
    CSAT = "1",
    EXIT = "2"
}

export enum TriggerPoint {
    ClearToClose = "0",
    MouseOut = "1",
    BrowserBack = "2",
    NavigateAway = "3"
}

export enum DealRoleType {
    Unknown = 0,
    Borrower = 1,
    CoBorrower = 2
}

export interface RatingSelection {
    rating: number;
    smileyImageSrc: string;
    ratingLabel: string;
    ratingDescription?: string;
    comment?: string;
}

export const surveyApi = createApi({
    reducerPath: "surveyApi",
    baseQuery: baseQueryWithAuth,
    tagTypes: ["survey"],
    endpoints: (build) => ({
        getSurveyDetails: build.query<Survey, { userId: string; nhDealApplicationId: string; surveyType: string }>({
            query: ({ userId, nhDealApplicationId, surveyType }) => `/survey/user/${userId}/nh-deal-application-id/${nhDealApplicationId}/survey-type/${surveyType}`,
            providesTags: ["survey"],
        }),
        createSurvey: build.mutation<Survey, { userId: string; nhDealApplicationId: string; surveyData: CreateSurveyDto }>({
            query: ({ userId, nhDealApplicationId, surveyData }) => ({
                url: `/survey/user/${userId}/nh-deal-application-id/${nhDealApplicationId}`,
                method: "POST",
                body: surveyData,
            }),
            invalidatesTags: ["survey"],
        }),
        updateSurvey: build.mutation<Survey, { surveyId: string; surveyData: Survey }>({
            query: ({ surveyId, surveyData }) => ({
                url: `/survey/${surveyId}`,
                method: "PATCH",
                body: surveyData,
            }),
            invalidatesTags: ["survey"]
        }),
        updateSurveyDisplayedCount: build.mutation<Survey, { surveyId: string }>({
            query: ({ surveyId }) => ({
                url: `/survey/${surveyId}/display-count`,
                method: "PATCH",
            }),
            invalidatesTags: ["survey"]
        }),
    }),
});

export const {
    useGetSurveyDetailsQuery,
    useCreateSurveyMutation,
    useUpdateSurveyMutation,
    useUpdateSurveyDisplayedCountMutation,
} = surveyApi;